export default __webpack_public_path__ + "static/media/higher_up_you_go_strapline_fuchsia.53a4c9a4.svg";